module.exports = __webpack_public_path__ + "42e14c0643042a08ce6befb6c45ff9b4.pdf";